import { render } from "./PimProductsOverview.vue?vue&type=template&id=b0134cb6&scoped=true&ts=true"
import script from "./PimProductsOverview.vue?vue&type=script&lang=ts"
export * from "./PimProductsOverview.vue?vue&type=script&lang=ts"

import "./PimProductsOverview.vue?vue&type=style&index=0&id=b0134cb6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0134cb6"]])

export default __exports__